export function clientInfoHeader(headers, appName, region): Headers {
  return {
    ...headers,
    'Client-Info': `${appName},latest,${region || 'external'}`
  };
}
